// Set proper video url to background video players based on screen size
$('.section__background-video .player').each(function() {
    let $video = $(this),
        urlDesktop = $(this).data('src-desktop'),
        urlMobile = $(this).data('src-mobile'),
        urlNew;

    // if no source element exists yet for video
    if (!$video.find('source').length > 0) {

        if (typeof urlDesktop !== 'undefined') {

            urlNew = urlDesktop;

            if (viewport().width < 992) {
                if (typeof urlMobile !== 'undefined' && "" !== urlMobile) {
                    urlNew = urlMobile;
                }
            }

            // append source element with url matching screen size
            $video.append('<source type="video/mp4" src="' + urlNew + '">');
        }
    }
});